export enum ColorThemeType {
  DEFAULT = 'DEFAULT',
  THEME_1 = 'THEME_1',
  THEME_2 = 'THEME_2',
  THEME_3 = 'THEME_3',
  THEME_4 = 'THEME_4',
  THEME_5 = 'THEME_5',
  THEME_6 = 'THEME_6',
  THEME_7 = 'THEME_7',
  THEME_8 = 'THEME_8',
  MIXED = 'MIXED',
  LIGHT = 'LIGHT',
}
